import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'flo-author-date',
  styleUrls: [],
  templateUrl: './author-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorDateComponent {
  @Input() public firstName: string | null

  @Input() public lastName: string | null

  @Input() public date: Date | null
}
